import cx from "classnames";
import { PropsWithChildren } from "react";
import cardStyles from "./Card.module.scss";
import cardHeaderStyles from "./CardHeader.module.scss";

type CardProps = {
  className?: string;
} & PropsWithChildren;

type CardHeaderProps = {
  icon?: React.ReactNode;
  title: string;
  action?: React.ReactNode;
} & PropsWithChildren;

export const Card = ({ children, className }: CardProps) => {
  const cardClasses = cx(cardStyles.card, className);
  return <div className={cardClasses}>{children}</div>;
};

export const CardHeader = ({ icon, title, action }: CardHeaderProps) => (
  <div className={cardHeaderStyles.container}>
    <div className={cardHeaderStyles.titleAndIcon}>
      {icon ? <div className={cardHeaderStyles.icon}>{icon}</div> : null}
      <div className={cardHeaderStyles.title}>{title}</div>
    </div>
    {action}
  </div>
);
